import React from 'react';

import { Route, Routes } from 'react-router-dom';

import { OfferType } from 'constants/enums';

import { OFFER_VIEW_CONFIG } from './OffersView.consts';

import '../../views/view.scss';

interface IOffersViewProps {
  offerType: OfferType;
}

export const OffersView = ({
  offerType
}: IOffersViewProps): React.ReactElement => {
  const {
    table: Table,
    form: Form,
    formParamName
  } = OFFER_VIEW_CONFIG[offerType];

  return (
    <Routes>
      <Route path="/" element={<Table />} />
      <Route path="/form" element={<Form />} />
      <Route path={`/form/:${formParamName}`} element={<Form edit />} />
      <Route path={`/dup/:${formParamName}`} element={<Form dup />} />
    </Routes>
  );
};
